// src/components/MaterialPhoneInput.jsx (o donde prefieras)

import React, { useState } from 'react';
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css' // Importa los estilos base

import { FormControl, InputLabel, useTheme } from '@mui/material'

const MaterialPhoneInput = React.forwardRef(function MaterialPhoneInput(props, ref) {
  const { label, value, onChange, error, helperText, name, color, labelFontSize, ...other } = props
  const [isFocused, setIsFocused] = useState(false)
  const theme = useTheme()

  // Determina los colores dinámicamente para imitar a TextField
  const getBorderColor = () => {
    if (error) {
      return theme.palette.error.main
    }
    if (isFocused) {
      return theme.palette.primary.main
    }
    if (color === 'success') {
        return theme.palette.success.main
    }
    return 'rgba(0, 0, 0, 0.23)' // Color por defecto de MUI
  }

  const getLabelColor = () => {
    if (error) {
      return theme.palette.error.main
    }
    if (isFocused) {
      return theme.palette.primary.main
    }
    if (color === 'success') {
      return theme.palette.success.main
    }
    return 'rgba(0, 0, 0, 0.6)' // Color de label por defecto
  }

  const hasValue = value && value.length > 2; // Un número de teléfono válido tiene más de 2 caracteres

  return (
    // FormControl gestiona el estado del label y helperText
    <FormControl
      variant="outlined"
      fullWidth
      error={error}
      sx={{ position: 'relative' }}
    >
      <InputLabel
        htmlFor={name}
        shrink={isFocused || hasValue} // El label se encoge si hay foco o valor
        sx={{
          color: getLabelColor(),
          // Ajustes finos para que el label se alinee perfectamente con el borde
          '&.Mui-focused': {
            color: theme.palette.primary.main,
          },
          '&.Mui-error': {
            color: theme.palette.error.main,
          },
          px: 1,
          transform: 'translate(75px, -9px) scale(0.75)',
          transformOrigin: 'top left',
          backgroundColor: 'white', // Fondo blanco para evitar superposición
          m: 0,
          p: 0,
          fontSize: labelFontSize
        }}
      >
        {label}
      </InputLabel>
      <PhoneInput
        {...other}
        ref={ref}
        name={name}
        value={value || ''}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        // Aplicamos los estilos dinámicos para que coincida con el borde de TextField
        style={{
          '--react-international-phone-border-color': getBorderColor(),
          '--react-international-phone-border-radius': '4px', // Borde de MUI
          '--react-international-phone-height': '56px', // Altura estándar de TextField
          width: '100%',
          maxWidth: '100%'
        }}
        inputStyle={{
          width: '100%',
          height: '56px',
          fontSize: '16px',
          borderRadius: '0 4px 4px 0',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          borderLeft: 'none',
          paddingLeft: '14px',
          paddingRight: '14px',
          boxSizing: 'border-box',
          outline: 'none'
        }}
        countrySelectorStyleProps={{
          buttonStyle: {
            height: '56px',
            borderRadius: '4px 0 0 4px',
            border: '1px solid rgba(0, 0, 0, 0.23)',
            borderRight: 'none',
            backgroundColor: '#fff',
            minWidth: '35px',
            maxWidth: '60px',
            padding: '0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: 'none'
          },
          dropdownStyleProps: {
            style: {
              maxHeight: '200px',
              overflow: 'auto',
              zIndex: 999
            }
          },
          flagStyle: {
            width: '30px',
            height: '25px',
            marginRight: '8px'
          }
        }}
        inputClassName="material-phone-input" // Clase para overrides si es necesario
      />
    </FormControl>
  )
});

export default MaterialPhoneInput;